import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import styled from "styled-components";
import { ReactComponent as GreyClock } from "../../images/time-grey.svg";

const OpeningHours = ({
  back,
  data,
  type,
  sameEveryDay,
  setsameEveryDay,
  opencloseTimeError,
  MoOpenSame,
  setMonOpenSame,
  MoCloseSame,
  setMonCloseSame,
  MoOpen,
  setMonOpen,
  MoClose,
  setMonClose,
  TuOpen,
  setTuOpen,
  TuClose,
  setTuClose,
  WeOpen,
  setWeOpen,
  WeClose,
  setWeClose,
  ThOpen,
  setThOpen,
  ThClose,
  setThClose,
  FrOpen,
  setFrOpen,
  FrClose,
  setFrClose,
  SaOpen,
  setSaOpen,
  SaClose,
  setSaClose,
  SuOpen,
  setSuOpen,
  SuClose,
  setSuClose,
  workingMo,
  setWorkingMo,
  workingTu,
  setWorkingTu,
  workingWe,
  setWorkingWe,
  workingTh,
  setWorkingTh,
  workingFr,
  setWorkingFr,
  workingSa,
  setWorkingSa,
  workingSu,
  setWorkingSu,
  setsameTimeDays,
  setDays,
  handleNextClick,
}) => {
  useEffect(() => {
    setsameEveryDay(data?.same_open_hours);
  }, []);

  useEffect(() => {
    setsameTimeDays([
      {
        dayName: "Monday",
        button_status: false,
        open: MoOpenSame ? moment(MoOpenSame).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
        close: MoCloseSame ? moment(MoCloseSame).format("HH:mm") : null,
      },
      {
        dayName: "Tuesday",
        open: MoOpenSame ? moment(MoOpenSame).format("HH:mm") : null,
        close: MoCloseSame ? moment(MoCloseSame).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
        button_status: false,
      },
      {
        button_status: false,
        open: MoOpenSame ? moment(MoOpenSame).format("HH:mm") : null,
        close: MoCloseSame ? moment(MoCloseSame).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
        dayName: "Wednesday",
      },
      {
        dayName: "Thursday",
        button_status: false,
        open: MoOpenSame ? moment(MoOpenSame).format("HH:mm") : null,
        close: MoCloseSame ? moment(MoCloseSame).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        close: MoCloseSame ? moment(MoCloseSame).format("HH:mm") : null,
        dayName: "Friday",
        button_status: false,
        open: MoOpenSame ? moment(MoOpenSame).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        openDate: null,
        closeDate: null,
        dayName: "Saturday",
        button_status: false,
        open: MoOpenSame ? moment(MoOpenSame).format("HH:mm") : null,
        close: MoCloseSame ? moment(MoCloseSame).format("HH:mm") : null,
      },
      {
        open: MoOpenSame ? moment(MoOpenSame).format("HH:mm") : null,
        close: MoCloseSame ? moment(MoCloseSame).format("HH:mm") : null,
        dayName: "Sunday",
        button_status: false,
        openDate: null,
        closeDate: null,
      },
    ]);
  }, [MoOpenSame, MoCloseSame]);

  useEffect(() => {
    setDays([
      {
        dayName: "Monday",
        button_status: false,
        open: workingMo && MoOpen ? moment(MoOpen).format("HH:mm") : null,
        close: workingMo && MoClose ? moment(MoClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Tuesday",
        button_status: false,
        open: workingTu && TuOpen ? moment(TuOpen).format("HH:mm") : null,
        close: workingTu && TuClose ? moment(TuClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Wednesday",
        button_status: false,
        open: workingWe && WeOpen ? moment(WeOpen).format("HH:mm") : null,
        close: workingWe && WeClose ? moment(WeClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Thursday",
        button_status: false,
        open: workingTh && ThOpen ? moment(ThOpen).format("HH:mm") : null,
        close: workingTh && ThClose ? moment(ThClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Friday",
        button_status: false,
        open: workingFr && FrOpen ? moment(FrOpen).format("HH:mm") : null,
        close: workingFr && FrClose ? moment(FrClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Saturday",
        button_status: false,
        open: workingSa && SaOpen ? moment(SaOpen).format("HH:mm") : null,
        close: workingSa && SaClose ? moment(SaClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Sunday",
        button_status: false,
        open: workingSu && SuOpen ? moment(SuOpen).format("HH:mm") : null,
        close: workingSu && SuClose ? moment(SuClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
    ]);
  }, [
    MoOpen,
    MoClose,
    TuOpen,
    TuClose,
    WeOpen,
    WeClose,
    ThOpen,
    ThClose,
    FrOpen,
    FrClose,
    SaOpen,
    SaClose,
    SuOpen,
    SuClose,
    workingMo,
    workingTu,
    workingWe,
    workingTh,
    workingFr,
    workingSa,
    workingSu,
  ]);

  useEffect(() => {
    let temp =
      type === "edit"
        ? data?.openingHours && typeof data?.openingHours === "string"
          ? JSON.parse(data?.openingHours)
          : data?.openingHours
        : data?.openingHours;
    if (
      type === "edit"
        ? data?.openingHours && typeof data?.openingHours === "string"
          ? JSON.parse(data?.openingHours)
          : data?.openingHours
        : data?.openingHours
    ) {
      temp?.map((day) => {
        if (day.dayName === "Tuesday") {
          setTuClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingTu(false)
          );
          setTuOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingTu(false)
          );
        }
        if (day.dayName === "Monday") {
          setMonOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingMo(false)
          );
          setMonClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingMo(false)
          );
        }

        if (day.dayName === "Thursday") {
          setThClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingTh(false)
          );
          setThOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingTh(false)
          );
        }
        if (day.dayName === "Friday") {
          setFrClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingFr(false)
          );
          setFrOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingFr(false)
          );
        }
        if (day.dayName === "Wednesday") {
          setWeClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingWe(false)
          );
          setWeOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingWe(false)
          );
        }

        if (day.dayName === "Sunday") {
          setSuClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingSu(false)
          );
          setSuOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingSu(false)
          );
        }
        if (day.dayName === "Saturday") {
          setSaClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingSa(false)
          );
          setSaOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingSa(false)
          );
        }
      });
    }

    if (
      type === "edit"
        ? data?.openingHours && typeof data?.openingHours === "string"
          ? JSON.parse(data?.openingHours)
          : data?.openingHours
        : data?.openingHours
    ) {
      temp?.map((day) => {
        if (day.dayName === "Tuesday") {
          setTuClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingTu(false)
          );
          setTuOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingTu(false)
          );
        }

        if (day.dayName === "Monday") {
          setMonClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingMo(false)
          );
          setMonOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingMo(false)
          );

          setMonCloseSame(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingMo(false)
          );

          setMonOpenSame(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingMo(false)
          );
        }

        if (day.dayName === "Thursday") {
          setThOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingTh(false)
          );
          setThClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingTh(false)
          );
        }
        if (day.dayName === "Friday") {
          setFrOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingFr(false)
          );
          setFrClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingFr(false)
          );
        }

        if (day.dayName === "Wednesday") {
          setWeOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingWe(false)
          );
          setWeClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingWe(false)
          );
        }

        if (day.dayName === "Sunday") {
          setSuOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingSu(false)
          );
          setSuClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingSu(false)
          );
        }
        if (day.dayName === "Saturday") {
          setSaClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingSa(false)
          );
          setSaOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingSa(false)
          );
        }
      });
    }

    if (
      type === "edit"
        ? data?.openingHours && typeof data?.openingHours === "string"
          ? JSON.parse(data?.openingHours)
          : data?.openingHours
        : data?.openingHours
    ) {
      temp?.map((day) => {
        if (day.dayName === "Monday") {
          setMonOpenSame(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingMo(false)
          );
          setMonCloseSame(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingMo(false)
          );
        }
      });
    }

    if (
      type === "edit"
        ? data?.openingHours && typeof data?.openingHours === "string"
          ? JSON.parse(data?.openingHours)
          : data?.openingHours
        : data?.openingHours
    ) {
      temp?.map((day) => {
        if (day.dayName === "Monday") {
          setMonOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingMo(false)
          );
          setMonClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingMo(false)
          );
        }
        if (day.dayName === "Wednesday") {
          setWeOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingWe(false)
          );
          setWeClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingWe(false)
          );
        }
        if (day.dayName === "Tuesday") {
          setTuOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingTu(false)
          );
          setTuClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingTu(false)
          );
        }

        if (day.dayName === "Thursday") {
          setThOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingTh(false)
          );
          setThClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingTh(false)
          );
        }
        if (day.dayName === "Friday") {
          setFrOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingFr(false)
          );
          setFrClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingFr(false)
          );
        }
        if (day.dayName === "Sunday") {
          setSuClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingSu(false)
          );
          setSuOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingSu(false)
          );
        }
        if (day.dayName === "Saturday") {
          setSaOpen(
            day.open != null && day.open.length > 0
              ? moment(day.open, "HH:mm").toDate()
              : setWorkingSa(false)
          );
          setSaClose(
            day.close != null && day.close.length > 0
              ? moment(day.close, "HH:mm").toDate()
              : setWorkingSa(false)
          );
        }
      });
    }
  }, [data]);

  const setWorkingDay = (day) => {
    if (day === "Mo") {
      setWorkingMo(!workingMo);
    }
    if (day === "Tu") {
      setWorkingTu(!workingTu);
    }
    if (day === "We") {
      setWorkingWe(!workingWe);
    }
    if (day === "Th") {
      setWorkingTh(!workingTh);
    }
    if (day === "Fr") {
      setWorkingFr(!workingFr);
    }
    if (day === "Sa") {
      setWorkingSa(!workingSa);
    }
    if (day === "Su") {
      setWorkingSu(!workingSu);
    }
  };
  const MainDiv = styled.div`
    width: 186px;
    height: 40px;
    border: 1px solid #e8e9eb;
    display: flex;
    align-items: center;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
  `;

  return (
    <div className="openin-hours-block">
      <div className="title">
        <h2>Please add Open hours</h2>
        <p>Let your visitors know when the attraction is open</p>
      </div>

      <div className="swipe-button">
        <p>Same Everyday</p>
        <label class="switch">
          <input
            type="checkbox"
            checked={sameEveryDay}
            onClick={() => setsameEveryDay(!sameEveryDay)}
          />
          <span class="slider round"></span>
        </label>
      </div>

      {sameEveryDay === true ? (
        <div className="timer-inline">
          <ul>
            <li>
              <p>Mo</p>
            </li>
            <li>
              <p>Tu</p>
            </li>
            <li>
              <p>We</p>
            </li>
            <li>
              <p>Th</p>
            </li>
            <li>
              <p>Fr</p>
            </li>
            <li>
              <p>Sa</p>
            </li>
            <li>
              <p>Su</p>
            </li>
          </ul>
          <div className="timer-row">
            <div className="timer-one">
              <DatePicker
                dropdownMode="select"
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={30}
                dateFormat="h:mm aa"
                autoComplete="off"
                selected={MoOpenSame}
                onChange={(value) => {
                  setMonOpenSame(value);
                }}
                calendarClassName="react-time-picker"
                popperClassName="react-time-propper"
                className="react-time-input"
              />
            </div>

            <div className="timer-one">
              <DatePicker
                selected={MoCloseSame}
                dropdownMode="select"
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={30}
                dateFormat="h:mm aa"
                autoComplete="off"
                onChange={(value) => {
                  setMonCloseSame(value);
                }}
                calendarClassName="react-time-picker"
                className="react-time-input"
                popperClassName="react-time-propper"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="time-block">
          <div className="opening-hours-cover">
            <div className="timer-col-50">
              <div className="opening-hours-row">
                <label
                  className="checkbox-row"
                  onClick={() => {
                    setWorkingDay("Mo");
                  }}
                >
                  <p className={workingMo ? "workingDay" : "nonWorkingDay"}>
                    Mo
                  </p>
                </label>
                {workingMo ? (
                  <div className="timer-row">
                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={MoOpen}
                        onChange={(value) => {
                          setMonOpen(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>

                    <div className="timer-one">
                      <DatePicker
                        selected={MoClose}
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        onChange={(value) => {
                          setMonClose(value);
                        }}
                        calendarClassName="react-time-picker"
                        className="react-time-input"
                        popperClassName="react-time-propper"
                      />
                    </div>
                  </div>
                ) : (
                  <MainDiv>
                    <GreyClock style={{ marginRight: 16, marginLeft: 19 }} />
                    <p style={{ color: "#161F3D", marginBottom: 0 }}>Closed</p>
                  </MainDiv>
                )}
              </div>
              <div className="opening-hours-row">
                <label
                  onClick={() => {
                    setWorkingDay("Tu");
                  }}
                  className="checkbox-row"
                >
                  <div className={workingTu ? "workingDay" : "nonWorkingDay"}>
                    Tu
                  </div>
                </label>
                {workingTu ? (
                  <div className="timer-row">
                    <div className="timer-one">
                      <DatePicker
                        selected={TuOpen}
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        onChange={(value) => {
                          setTuOpen(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>

                    <div className="timer-one">
                      <DatePicker
                        selected={TuClose}
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        onChange={(value) => {
                          setTuClose(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>
                  </div>
                ) : (
                  <MainDiv>
                    <GreyClock style={{ marginLeft: 20, marginRight: 16 }} />
                    <p style={{ marginBottom: 0, color: "#161F3D" }}>Closed</p>
                  </MainDiv>
                )}
              </div>
              <div className="opening-hours-row">
                <label
                  className="checkbox-row"
                  onClick={() => {
                    setWorkingDay("We");
                  }}
                >
                  <div className={workingWe ? "workingDay" : "nonWorkingDay"}>
                    We
                  </div>
                </label>
                {workingWe ? (
                  <div className="timer-row">
                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={WeOpen}
                        onChange={(value) => {
                          setWeOpen(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>

                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={WeClose}
                        onChange={(value) => {
                          setWeClose(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>
                  </div>
                ) : (
                  <MainDiv>
                    <GreyClock style={{ marginLeft: 20, marginRight: 16 }} />
                    <p style={{ marginBottom: 0, color: "#161F3D" }}>Closed</p>
                  </MainDiv>
                )}
              </div>
              <div className="opening-hours-row">
                <label
                  className="checkbox-row"
                  onClick={() => {
                    setWorkingDay("Th");
                  }}
                >
                  <div className={workingTh ? "workingDay" : "nonWorkingDay"}>
                    Th
                  </div>
                </label>
                {workingTh ? (
                  <div className="timer-row">
                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={ThOpen}
                        onChange={(value) => {
                          setThOpen(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>

                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={ThClose}
                        onChange={(value) => {
                          setThClose(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>
                  </div>
                ) : (
                  <MainDiv>
                    <GreyClock style={{ marginLeft: 20, marginRight: 16 }} />
                    <p style={{ marginBottom: 0, color: "#161F3D" }}>Closed</p>
                  </MainDiv>
                )}
              </div>
              <div className="opening-hours-row">
                <label
                  className="checkbox-row"
                  onClick={() => {
                    setWorkingDay("Fr");
                  }}
                >
                  <div className={workingFr ? "workingDay" : "nonWorkingDay"}>
                    Fr
                  </div>
                </label>
                {workingFr ? (
                  <div className="timer-row">
                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={FrOpen}
                        onChange={(value) => {
                          setFrOpen(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>

                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={FrClose}
                        onChange={(value) => {
                          setFrClose(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>
                  </div>
                ) : (
                  <MainDiv>
                    <GreyClock style={{ marginLeft: 20, marginRight: 16 }} />
                    <p style={{ marginBottom: 0, color: "#161F3D" }}>Closed</p>
                  </MainDiv>
                )}
              </div>
            </div>
            <div className="timer-col-50">
              <div className="opening-hours-row">
                <label
                  className="checkbox-row"
                  onClick={() => {
                    setWorkingDay("Sa");
                  }}
                >
                  <div className={workingSa ? "workingDay" : "nonWorkingDay"}>
                    Sa
                  </div>
                </label>
                {workingSa ? (
                  <div className="timer-row">
                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={SaOpen}
                        onChange={(value) => {
                          setSaOpen(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>

                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={SaClose}
                        onChange={(value) => {
                          setSaClose(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>
                  </div>
                ) : (
                  <MainDiv>
                    <GreyClock style={{ marginLeft: 20, marginRight: 16 }} />
                    <p style={{ marginBottom: 0, color: "#161F3D" }}>Closed</p>
                  </MainDiv>
                )}
              </div>
              <div className="opening-hours-row">
                <label
                  className="checkbox-row"
                  onClick={() => {
                    setWorkingDay("Su");
                  }}
                >
                  <div className={workingSu ? "workingDay" : "nonWorkingDay"}>
                    Su
                  </div>
                </label>
                {workingSu ? (
                  <div className="timer-row">
                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={SuOpen}
                        onChange={(value) => {
                          setSuOpen(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>

                    <div className="timer-one">
                      <DatePicker
                        dropdownMode="select"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        autoComplete="off"
                        selected={SuClose}
                        onChange={(value) => {
                          setSuClose(value);
                        }}
                        className="react-time-input"
                        calendarClassName="react-time-picker"
                        popperClassName="react-time-propper"
                      />
                    </div>
                  </div>
                ) : (
                  <MainDiv>
                    <GreyClock style={{ marginLeft: 20, marginRight: 16 }} />
                    <p style={{ marginBottom: 0, color: "#161F3D" }}>Closed</p>
                  </MainDiv>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="error-msg">
        {opencloseTimeError === true ? (
          <p className="error-message">
            Closing Time should not be Greater than Opening Time
          </p>
        ) : null}
      </div>

      <div className="event-button-row submit">
        <button className="back-btn submit-btn" onClick={() => back()}>
          Back
        </button>
        <button
          className="next-btn submit-btn"
          onClick={() => handleNextClick()}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default OpeningHours;
